import gql from 'graphql-tag';

export const GET_INVOICE_DOCUMENT = gql`
  query GetInvoiceDocument($VOId: ID) {
    result: invoiceDoc(VOId: $VOId) {
      source
      docType
      docName
      createdBy
      documentId
      docDescription
      createdDateTime
      createdDateTime
      vendorOpportunityId
    }
  }
`;
